export const onToolbarPreparingFactory = (options) => {
    const { isPhoneView, handleExportChangelog, reloadData, allowExport, filterGroup } = options;
    const onToolbarPreparing = (toolbar) => {
        const { toolbarOptions } = toolbar;
        if (!toolbarOptions || !toolbarOptions.items) {
            return;
        }
        const itemLocation = isPhoneView ? 'before' : 'after';
        toolbarOptions.items.unshift({
            location: itemLocation,
            template: 'resultsCounter',
        });
        toolbarOptions.items.push({
            location: itemLocation,
            template: 'refreshData',
            onClick: reloadData,
        });
        toolbarOptions.items.push({
            location: itemLocation,
            template: 'exportCsv',
            onClick: handleExportChangelog,
            shouldRender: allowExport,
        });
        const { filters } = filterGroup !== null && filterGroup !== void 0 ? filterGroup : { filters: undefined };
        if (Array.isArray(filters)) {
            toolbarOptions.items.unshift({
                location: 'before',
                template: 'filterFields',
                filterGroup,
                shouldRender: true,
            });
        }
    };
    return onToolbarPreparing;
};
//# sourceMappingURL=onToolbarPreparing.js.map